import { firebase } from '@firebase/app'
import '@firebase/firestore'
import '@firebase/functions'
import '@firebase/auth'
import '@firebase/storage'

let firebaseapp = firebase.initializeApp({
  apiKey: 'AIzaSyD0AqLPiG7L63pwxoPyvEw-luwY83AFOQI',
  authDomain: 'speedpowerplay.firebaseapp.com',
  databaseURL: 'https://speedpowerplay.firebaseio.com',
  projectId: 'speedpowerplay',
  storageBucket: 'speedpowerplay.appspot.com',
  messagingSenderId: '350271259524',
  appId: '1:350271259524:web:9037c7da3dfd021a0e93d1',
  measurementId: 'G-0VXBMX1ST5'
})

firebaseapp.firestore().enablePersistence()
  .catch(function (err) {
    if (err.code === 'failed-precondition') {
      alert('offline data only works with one tab at a time')
    } else if (err.code === 'unimplemented') {
      alert('browser does not support offline data')
    }
  })

firebaseapp.auth().onAuthStateChanged(function (user) {
  if (user) {
    user.getIdTokenResult().then(function (idTokenResult) {
      firebaseapp.user = user
      firebaseapp.token = idTokenResult.token
    }).catch((error) => {
      alert(error)
    })
  }
})

export default firebaseapp
